var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2749 0.917969H5.71263C4.61416 0.917969 3.72044 1.81168 3.72044 2.91015V3.15466H2.40283C1.30436 3.15466 0.410645 4.04837 0.410645 5.14684V16.9259C0.410645 18.0243 1.30436 18.9181 2.40283 18.9181H9.96506C11.0635 18.9181 11.9572 18.0243 11.9572 16.9259V16.6814H13.2748C14.3732 16.6814 15.267 15.7877 15.267 14.6892V2.91015C15.267 1.81168 14.3733 0.917969 13.2749 0.917969ZM10.6722 16.9259C10.6722 17.3158 10.3549 17.633 9.96515 17.633H2.40283C2.01294 17.633 1.6957 17.3158 1.6957 16.9259V5.14676C1.6957 4.75687 2.01294 4.43963 2.40283 4.43963H9.96506C10.3549 4.43963 10.6721 4.75687 10.6721 5.14676V16.9259H10.6722ZM13.982 14.6892C13.982 15.0791 13.6647 15.3963 13.2749 15.3963H11.9572V5.14676C11.9572 4.04829 11.0635 3.15457 9.96515 3.15457H5.0055V2.91007C5.0055 2.52018 5.32274 2.20294 5.71263 2.20294H13.2749C13.6647 2.20294 13.982 2.52018 13.982 2.91007V14.6892Z",
    fill: "#15466B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.027ba4fe6c87bb813d443a12c426e938.svg";
export { ForwardRef as ReactComponent };